module.exports = __webpack_public_path__ + "img/4-1.10560e81.png";